import { render, staticRenderFns } from "./profileEdit.vue?vue&type=template&id=39a112b8"
import script from "./profileEdit.vue?vue&type=script&lang=js"
export * from "./profileEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports